import { render, staticRenderFns } from "./CustomerNotificationsProvider.vue?vue&type=template&id=6e58f626&scoped=true"
import script from "./CustomerNotificationsProvider.vue?vue&type=script&lang=ts"
export * from "./CustomerNotificationsProvider.vue?vue&type=script&lang=ts"
import style0 from "./CustomerNotificationsProvider.vue?vue&type=style&index=0&id=6e58f626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e58f626",
  null
  
)

export default component.exports